export const APP_ROUTES = {
  default: '/',
  catchAll: '*',
  aires: '/aires',
  loansMapping: '/loans-mapping',
  loansUploadMapping: '/loans-mapping/upload',
  sharesMapping: '/shares-mapping',
  sharesUploadMapping: '/shares-mapping/upload',
  codeMapping: '/code-mapping',
  codeUploadMapping: '/code-mapping/upload',
  uploadHistory: '/upload-history',
  dataManagement: '/data-management',
} as const;
